const showMoreButton = document.getElementsByClassName("show-more")[0]

showMoreButton.addEventListener("click", () => {
    const content = document.getElementsByClassName("perks-content")[0]
    const fadeAway = document.getElementsByClassName("fade-away")[0]
    content.classList.remove("overflow")
    showMoreButton.classList.add("hidden")
    fadeAway.classList.add("remove")
})
